import { apiSlice } from '@/redux/api.slice';

export type EmailClickBody = {
  category: string;
  path: string;
};

export const emailClickApi = apiSlice.injectEndpoints({
  overrideExisting: process.env.NODE_ENV !== 'production',
  endpoints: (builder) => ({
    reportEmailClick: builder.mutation<void, EmailClickBody>({
      query: (body) => ({
        url: 'api/email-click',
        method: 'POST',
        body
      })
    })
  })
});

export const { useReportEmailClickMutation } = emailClickApi;
